import {
  Box,
  Text,
  Button,
  Stack,
  styled,
  Input,
} from '@ltvco/refresh-lib/theme';

export const PopoverContainer = styled(Box)(({ theme }) => ({
  width: '340px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '100vw',
    maxWidth: '100vw',
  },
}));

export const Header = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const Title = styled(Text)(() => ({
  fontWeight: 600,
  fontSize: '1.125rem',
}));

export const ContentBody = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const FieldLabel = styled(Text)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.75),
}));

export const StyledInput = styled(Input)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.common.white,
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.palette.primary.main}20`,
    },
    '&:before, &:after': {
      display: 'none',
    },
  },
  '& .MuiInputBase-input': {
    padding: '10px 14px',
    fontSize: '0.875rem',
    '&::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
  },
}));

export const Footer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(0, 2.5, 2.5, 2.5),
}));

export const ApplyButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '24px',
  padding: theme.spacing(1.25, 3),
  width: '100%',
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  borderRadius: '24px',
  padding: theme.spacing(1.25, 3),
  width: '100%',
  borderColor: theme.palette.divider,
  color: theme.palette.primary.main,
}));
